/**
 * If the user hits an endpoint that doesn't exist, just redirect them to /Policies/List.
 */
(function(app) {
    app.config(["$urlRouterProvider", function($urlRouterProvider) {
        $urlRouterProvider.otherwise("/Policies/List");
    }]);
})(window.app);
